import { render, staticRenderFns } from "./AllocationsEditTable.vue?vue&type=template&id=74ca58f6&scoped=true"
import script from "./AllocationsEditTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AllocationsEditTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AllocationsEditTable.vue?vue&type=style&index=0&id=74ca58f6&prod&scoped=true&lang=css"
import style1 from "./AllocationsEditTable.vue?vue&type=style&index=1&id=74ca58f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ca58f6",
  null
  
)

export default component.exports